//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { InputLikeButton } from "../../../../components/form-elements/special-inputs";
import Icon from "../../../../components/ui-elements/Icon";
import { useSubjectSelectorContext } from "../SubjectSelector/hook";
import { useSubjectPicker } from "./hook";
import { useSubjectSelector } from "../SubjectSelector/hook";

export function SubjectPickerDrawerOrModal({
  options,
  placeholder,
  isOpen,
  onClose,
  valueProp,
  onChange,
  headerText = "Select subjects",
  headerSubText = "What subjects need help?",
  subjectPrompt = "Selecting many subjects may require more teachers and increase lesson cost.",
}: any) {
  const { value, isMobile, handleChange } = useSubjectPicker(
    valueProp,
    options,
    placeholder
  );

  const handleSave = () => {
    onChange && onChange(value);
    onClose();
  };
  return (
    <>
      {isMobile ? (
        <Drawer
          isOpen={isOpen}
          placement="bottom"
          onClose={onClose}
          // scrollBehavior="inside"
          isFullHeight={options.length > 10 ? true : false}
          closeOnOverlayClick={false}
        >
          <DrawerOverlay />
          <DrawerContent
            borderRadius={options.length > 10 ? "none" : "12px 12px 0 0"}
            borderWidth="2xs"
            overflow="scroll"
          >
            <DrawerCloseButton />
            <DrawerHeader borderBottomWidth="xs" bg="neutral.200">
              <Box>
                <Text>{headerText}</Text>
                <Text fontSize="md" opacity={0.8} fontWeight="normal">
                  {headerSubText}
                </Text>
              </Box>
            </DrawerHeader>

            <DrawerBody py={5}>
              <CheckboxGroup
                size="lg"
                colorScheme="blue"
                defaultValue={value}
                onChange={handleChange}
              >
                <Stack spacing={4}>
                  {options.map((option) => (
                    <Checkbox
                      id="subjects"
                      key={option.value}
                      value={option.value}
                    >
                      <Text fontSize="md">{option.label}</Text>
                    </Checkbox>
                  ))}
                </Stack>
              </CheckboxGroup>
            </DrawerBody>
            {value.length > 4 && excessSubjectPrompt(subjectPrompt)}
            <DrawerFooter borderTopWidth="3xs">
              <Button variant="outline" mr={3} onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={handleSave} colorScheme="blue">
                Save
              </Button>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      ) : (
        <Modal onClose={onClose} isOpen={isOpen} closeOnOverlayClick={false}>
          <ModalOverlay />
          <ModalContent
            top="2.5rem"
            mx={2}
            height="fit-content"
            rounded="fbRadius"
            shadow="fbShadow"
            borderWidth="2xs"
            overflow="hidden"
          >
            <ModalHeader borderBottomWidth="xs" bg="neutral.200">
              <Box>
                <Text>{headerText}</Text>
                <Text fontSize="md" opacity={0.8} fontWeight="normal">
                  {headerSubText}
                </Text>
              </Box>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody pt={4} pb={6}>
              <CheckboxGroup
                size="lg"
                colorScheme="blue"
                defaultValue={value}
                onChange={handleChange}
              >
                <Stack spacing={4}>
                  {options.map((option) => (
                    <Checkbox
                      id="subjects"
                      key={option.value}
                      value={option.value}
                    >
                      <Text fontSize="md">{option.label}</Text>
                    </Checkbox>
                  ))}
                </Stack>
              </CheckboxGroup>
            </ModalBody>
            {value.length > 4 && excessSubjectPrompt(subjectPrompt)}
            <ModalFooter borderTopWidth="3xs">
              <Button variant="outline" onClick={onClose} mr={3}>
                Cancel
              </Button>
              <Button onClick={handleSave} colorScheme="blue">
                Save
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  );
}

const SubjectPicker: React.FC<any> = ({
  options,
  value: valueProp,
  headerText,
  subjectPrompt,
  onChange,
  values,
  placeholder,
  isInvalid,
  ...rest
}) => {
  const { onOpen, updatePlaceholder, subjects, subjectUpdated }: any =
    useSubjectSelectorContext();

  const { renderText } = useSubjectPicker(valueProp, options, placeholder);
  useEffect(() => {
    // console.log({ placeholder });
    updatePlaceholder(placeholder);
  }, [placeholder]);

  useEffect(() => {
    // for initial values to persist only update this subjects on user action
    if (subjectUpdated && onChange) onChange(subjects);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subjects, subjectUpdated]);
  return (
    <Box>
      <InputLikeButton
        height="48px"
        onClick={() => {
          onOpen({ options, placeholder });
        }}
        _active={{ borderWidth: "xs", borderColor: "blue.500" }}
        _focus={{ borderWidth: "xs", borderColor: "blue.500" }}
        _invalid={{ borderWidth: "xs", borderColor: "red.500" }}
        {...{ isInvalid }}
        {...rest}
      >
        {renderText()}
      </InputLikeButton>
    </Box>
  );
};

export default SubjectPicker;

const excessSubjectPrompt = (prompt, color = "orange") => (
  <Stack
    isInline
    py={3}
    px={5}
    spacing={3}
    align="center"
    borderTopWidth="xs"
    borderColor={`${color}.300`}
    bg={`${color}.50`}
    // fontSize="sm"
  >
    <Icon name="warning" color={`${color}.500`} />
    <Text lineHeight="short">{prompt}</Text>
  </Stack>
);
